module.exports = __webpack_public_path__ + "static/media/watchlist--dark.8dcd2d3d.png";